import { Dispatch } from 'react';
import { Structure } from 'api';

export enum SourceType {
    STRUCTURE = 'structure',
    STOREY = 'storey',
}

export enum StructureCopyAction {
    EnterCopyMode = 'ENTER_COPY_MODE',
    ExitCopyMode = 'EXIT_COPY_MODE',
    ToggleOriginStructure = 'TOGGLE_ORIGIN_STRUCTURE',
    ToggleDestinations = 'TOGGLE_DESTINATIONS',
    ClearDestinations = 'CLEAR_DESTINATIONS',
    SetDestinationSelection = 'SET_DESTINATION_SELECTION',
    EnterReferenceCopyMode = 'ENTER_REFERENCE_COPY_MODE',
    SetNameToDestination = 'SET_NAME_TO_DESTINATION',
    SetReferenceFlag = 'SET_REFERENCE_FLAG',
    SetReferenceStructureId = 'SET_REFERENCE_STRUCTURE_ID',
    SetOriginStructures = 'SET_ORIGIN_STRUCTURES',
    ClearOriginStructures = 'CLEAR_ORIGIN_STRUCTURES',
    ClearOriginStructure = 'CLEAR_ORIGIN_STRUCTURE',
    SetSourceType = 'SET_SOURCE_TYPE',
    SetStoreyReferencesData = 'SET_STOREY_REFERENCES_DATA',
    AddDestination = 'ADD_DESTINATION',
}

export type StructureParams = {
    id: string;
    svgPolygonPath: string;
    name: string;
    structureId: string;
};

export type DestinationStructure = {
    parentId: string;
    svgPolygonPath: string;
    floorNumber?: number;
    name?: string;
    originStructureId?: string;
};

export type StoreyReferenceItem = {
    id: string;
    name: string;
    floorNumber: number;
};

export type StructureCopyState = {
    isInCopyMode: boolean;
    isDestinationSelection: boolean;
    originStructure: StructureParams | null;
    destinationStructures: DestinationStructure[];
    isInReferenceCopyMode: boolean;
    isReference: boolean;
    referenceStructureId: string | null;
    originStructures: Structure[];
    sourceType: SourceType;
    storeyReferencesData: StoreyReferenceItem[];
};

export type StructureCopyActionType =
    | {
          type: StructureCopyAction.EnterCopyMode;
      }
    | {
          type: StructureCopyAction.ExitCopyMode;
      }
    | {
          type: StructureCopyAction.ToggleOriginStructure;
          payload: StructureParams | null;
      }
    | {
          type: StructureCopyAction.ToggleDestinations;
          payload: DestinationStructure;
      }
    | {
          type: StructureCopyAction.SetDestinationSelection;
          payload: boolean;
      }
    | {
          type: StructureCopyAction.SetReferenceFlag;
          payload: boolean;
      }
    | {
          type: StructureCopyAction.SetReferenceStructureId;
          payload: string | null;
      }
    | {
          type: StructureCopyAction.SetOriginStructures;
          payload: Structure[];
      }
    | {
          type: StructureCopyAction.ClearDestinations;
      }
    | {
          type: StructureCopyAction.ClearOriginStructure;
      }
    | {
          type: StructureCopyAction.ClearOriginStructures;
      }
    | {
          type: StructureCopyAction.EnterReferenceCopyMode;
      }
    | {
          type: StructureCopyAction.SetNameToDestination;
          payload: {
              destination: DestinationStructure;
              name: string;
          };
      }
    | {
          type: StructureCopyAction.SetSourceType;
          payload: SourceType;
      }
    | {
          type: StructureCopyAction.SetStoreyReferencesData;
          payload: StoreyReferenceItem[];
      }
    | {
          type: StructureCopyAction.AddDestination;
          payload: DestinationStructure;
      };

export type StructureCopyContextProps = {
    state: StructureCopyState;
    dispatch: Dispatch<StructureCopyActionType>;
};
